'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	MONTHS: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	],
	VALIDATED_INPUT: {
		EMAIL: {
			SUGGESTION: 'Did you mean to type <a class="disabled">$[suggestion]</a>?'
		}
	}
});
